import React from "react";
import { Divider, Paper } from "convertupleads-theme";
import PageTitleBox from "../../../common/PageTitleBox";
import BasicRating from "./BasicRating";
import RatingPrecision from "./RatingPrecision";
import HoverFeedbackRating from "./HoverFeedbackRating";
import RatingSize from "./RatingSize";

const RatingPage = () => {
  return (
    <Paper elevation={0}>
      <PageTitleBox
        title={"Rating"}
        description={
          "Ratings provide insight regarding others' opinions and experiences, and can allow the user to submit a rating of their own."
        }
      />
      <Divider light />

      <BasicRating />
      <RatingPrecision />
      <HoverFeedbackRating />
      <RatingSize />
    </Paper>
  );
};

export default RatingPage;
